export default __webpack_public_path__ + "static/frame-006-0e501b2c9490feccc12d1cd2ba2e7888.png";